<template>
  <!-- Footer for the content pages. The internal links also give crawlers a
       path back to the hub from every brand page. -->
  <footer class="border-t border-gray-900 bg-gray-950">
    <PageContainer class="flex flex-col gap-6 py-10 sm:flex-row sm:items-center sm:justify-between">
      <nav aria-label="Footer" class="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm">
        <TextLink href="/" tone="muted" @click="trackFooterLink('generator')">Palette generator</TextLink>
        <TextLink href="/brand-colors" tone="muted" @click="trackFooterLink('brand colors')">Brand colors</TextLink>
        <TextLink href="/blog" tone="muted" @click="trackFooterLink('blog')">Blog</TextLink>
        <!-- The extension's own landing page rather than the Web Store listing:
             it is where the install button lives, it is indexable, and it gives
             every page on the site an internal link into it. -->
        <TextLink href="/browser-extension" tone="muted" @click="trackFooterLink('browser extension')">Browser Extension</TextLink>
        <TextLink :href="apiUrl('footer_link', route.path)" tone="muted" @click="trackFooterLink('api')">API</TextLink>
      </nav>
      <PrefetchCredit v-if="credit" />
    </PageContainer>
  </footer>
</template>

<script setup>
import { trackEvent } from '~/composables/analytics'
import PageContainer from '~/components/atoms/PageContainer.vue'
import TextLink from '~/components/atoms/TextLink.vue'
import PrefetchCredit from '~/components/molecules/PrefetchCredit.vue'
import { apiUrl } from '~/utils/site'

// The brand hub carries the same credit in its pinned search bar, so it turns
// this one off rather than showing it twice.
defineProps({
  credit: { type: Boolean, default: true },
})

// The footer is the same on every content page, so the destination is in the
// event name and the page it was clicked from is a parameter — and, for the
// outbound link, rides along in the URL so Prefetch sees it too.
const route = useRoute()

const trackFooterLink = (destination) => {
  try {
    trackEvent(`Footer Link Clicked (${destination})`, { page: route.path })
  } catch {}
}
</script>
